<template>
    <div class="home-sales-map-section" id="home-sales-map-section">
        <div class="container">
            <div class="section-title">
                <h2>{{ indexPage.sales_map_title }}</h2>
            </div>
            <div class="sales-map-main">
                <div class="map salesMapMain" id="salesMapMain" :class="{'map-lock' : lockMap}"></div>
                <a href="#" class="unlock-map-btn" @click.prevent="lockMap = !lockMap" :class="{'unlock-link' : !lockMap}">
                    <div class="link-in">
                        <div class="icon-item">
                            <svgIcon name="lock" class="icon-lock" :class="{'hide' : !lockMap}"/>
                            <svgIcon name="unlock" class="icon-unlock" :class="{'show' : !lockMap}"/>
                        </div>
                        <span :class="{'unlock' : !lockMap}">Разблокировать карту</span>
                    </div>
                </a>
                <div class="mobile-pin-info-container" v-if="isMobileChecker && initMobilePinInfo">
                    <router-link :to="'/sales/' + infoMobilePinData.link" v-if="infoMobilePinData.link != null" class="link-to-project">
                        <h3>{{ infoMobilePinData.title }}</h3>
                        <p>{{ infoMobilePinData.adres }}</p>
                        <strong>от <span>{{ infoMobilePinData.price }}</span> млн.тг.</strong>
                    </router-link>
                    <a href="#" class="close-btn" @click.prevent="resetDataPinMobile">
                        <svgIcon name="close" class="icon-close"/>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue'
    export default {
        name: 'home-sales-map-section',
        components: {
            svgIcon,
        },
        data () {
            return {
                globalLang: window.GlobalLang, 
                initMobilePinInfo: false,
                infoMobilePinData: {
                    link: null,
                    title: null,
                    adres: null,
                    price: null,
                },
                zoom: 13,
                offsetHorizontal: 100,
                offsetVertical: 135,
                activeBallon: null,
                lockMap: false,
            }
        },
        computed: mapGetters({
            indexPage: 'loadIndexPage',
            salesItems: 'loadSalesItemsDefault',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            initMap() {
                this.$loadScript("https://api-maps.yandex.ru/2.1/?apikey=e684e26f-c03a-4724-9b73-bca23bfbccaf&lang=ru_RU")
                .then(() => {
                    if (this.salesItems != null) {
                        const initMobilePinInfo = this.initMobilePinInfo;
                        var _self = this;
                        var zoom = this.zoom;
                        var offset_horizontal = this.offsetHorizontal;
                        var offset_vertical = this.offsetVertical;
                        var i;
                        var Ymap;
                        ymaps.ready().then(function() {
                            var initMap = function() {
                                Ymap = new ymaps.Map('salesMapMain', {
                                    center: [43.229462, 76.913048],
                                    zoom: zoom,
                                    controls: [],
                                    behaviors: ["drag", "rightMouseButtonMagnifier", "multiTouch", "scrollZoom"]
                                },{suppressMapOpenBlock: false, minZoom: 11, maxZoom: 18, yandexMapDisablePoiInteractivity: true});
                                // Ymap.controls.add('zoomControl', {position: {right: '10px', top: '180px'}});
                                // Ymap.options.set('maxAnimationZoomDifference', Infinity);
                                var btnZoomInLayout = ymaps.templateLayoutFactory.createClass(
                                    '<button class="btn-zoom-in ymap-home-btn-zoom"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13 11V5H11V11H5V13H11V19H13V13H19V11H13Z"></path></svg></button>'
                                );
                                var btnZoomOutLayout = ymaps.templateLayoutFactory.createClass(
                                    '<button class="btn-zoom-out ymap-home-btn-zoom"><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M5 11V13L19 13V11L5 11Z"></path></svg></button>'
                                );
                                var zoomInButton = new ymaps.control.Button({
                                    data: { content: '' },
                                    options: { selectOnClick: false, layout: btnZoomInLayout }
                                });
                                var zoomOutButton = new ymaps.control.Button({
                                    data: { content: '-' },
                                    options: { selectOnClick: false, layout: btnZoomOutLayout }
                                });
                                zoomInButton.events.add('click', function () {
                                    Ymap.setZoom(Ymap.getZoom() + 1, { duration: 300, checkZoomRange: true });
                                });
                                zoomOutButton.events.add('click', function () {
                                    Ymap.setZoom(Ymap.getZoom() - 1, { duration: 300, checkZoomRange: true });
                                });
                                Ymap.controls.add(zoomInButton, { float: 'none', position: { top: 170, right: 20 } });
                                Ymap.controls.add(zoomOutButton, { float: 'none', position: { top: 225, right: 20 } });
                            };
                            
                            var buildPinsOnMap = function() {
                                for (i = 0; i < _self.salesItems.length; i++) {
                                    var lat = _self.salesItems[i].project_map_lat,
                                        lng = _self.salesItems[i].project_map_lng,
                                        proejct_title = _self.salesItems[i].name.name;
                                    
                                    const customLayout = ymaps.templateLayoutFactory.createClass(
                                        '<div class="yandex-dial-point" style="width: $[properties.iconWidth]px; height: $[properties.iconHeight]px;">'+ 
                                            '<div class="point-layout">' +
                                                '<a href="/sales/' + _self.salesItems[i].name.slug +'">' +
                                                    '<div class="marker-img">'+ 
                                                        '<div class="img-in">' +
                                                            '<img src="' + _self.salesItems[i].project_map_marker + '"/>' +
                                                        '</div>' +
                                                    '</div>' +
                                                    '<div class="marker-info">' +
                                                        '<h3>' + _self.salesItems[i].name.name + '</h3>' +
                                                        '<p>' + _self.salesItems[i].project_adres + '</p>' +
                                                        '<strong> от <span>' + _self.salesItems[i].project_price_full + '</span> млн.тг.</strong>' +
                                                    '</div>' +
                                                '</a>' +    
                                            '</div>' +
                                        '</div>'
                                    );

                                    const myPlacemark = new ymaps.Placemark([lat, lng], 
                                        {
                                            hintContent: '',
                                            balloonContent: "",
                                        },
                                        {
                                            preset: "islands#circleDotIcon",
                                            iconLayout: customLayout,
                                            iconImageSize: [8, 8],
                                            iconImageOffset: [-4, -8],
                                            zIndex: 730,
                                            zIndexActive: 732,
                                            zIndexHover: 731,
                                            iconPane: "overlaps",
                                            data_title:  _self.salesItems[i].name.name,
                                            data_slug: _self.salesItems[i].name.slug,
                                            data_adres: _self.salesItems[i].project_adres,
                                            data_price: _self.salesItems[i].project_price_full,
                                        }
                                    );
                                    Ymap.geoObjects.add(myPlacemark);
                                    myPlacemark.events.add("click", (function(e) {
                                        if (_self.isMobileChecker) {
                                            e.preventDefault();
                                            _self.initMobilePinInfo = true;
                                            // var data = myPlacemark.options.get('iconLayout').data;
                                            const dataAtribute = e.get('target').options.get('data_title');
                                            _self.infoMobilePinData.link = e.get('target').options.get('data_slug')
                                            _self.infoMobilePinData.title = e.get('target').options.get('data_title')
                                            _self.infoMobilePinData.adres = e.get('target').options.get('data_adres')
                                            _self.infoMobilePinData.price = e.get('target').options.get('data_price')
                                            console.log(dataAtribute, _self.infoMobilePinData, 'asdasdas 99999')
                                        }
                                    }));
                                }
                            };

                            var setCenterOffset = function() {
                                var pixelCenter = Ymap.getGlobalPixelCenter('Ymap');
                                pixelCenter = [
                                    pixelCenter[0] + offset_horizontal,
                                    pixelCenter[1] - offset_vertical
                                ];
                                var geoCenter = Ymap.options.get('projection').fromGlobalPixels(pixelCenter, Ymap.getZoom());
                                Ymap.setCenter(geoCenter);
                            };

                            initMap();
                            buildPinsOnMap();
                            setCenterOffset();
                        });
                    }
                });
            },
            resetDataPinMobile() {
                this.initMobilePinInfo = null;
                this.infoMobilePinData.link = null;
                this.infoMobilePinData.title = null;
            },
        },
        beforeCreate() {
        },
        created () {
            
        },
        mounted() {
            this.initMap();
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/home-page/home-sales-map.scss';
    @import '@/styles/components/home-page/respond/home-sales-map-respond.scss';
</style>